import React from "react";
import { graphql } from "gatsby";
import ReactMarkdown from "react-markdown";
import {SideContent} from "../components/sideContent/sideContent";
import {CaseStats} from "../components/caseStats/caseStats";
import {StrapiLayout, BlogLayout, Divider} from "@klear/open-site";
const {Helmet} = require("react-helmet");

const styles = require("../styles/index.module.scss");

export default ({ data }) => {
    const caseStudy = data.allStrapiCaseStudy.edges[0].node;
    const footerData = data.strapiFooter;

    return (
        <StrapiLayout footerProps={footerData}>
            <Helmet>
                <title>{caseStudy.pageTitle}</title>
                <meta name="description" content={caseStudy.pageDescription} />
                {caseStudy.mainImage?.url &&
                <meta name="image" content={caseStudy.mainImage.url} /> &&
                <meta property="og:image" content={caseStudy.mainImage.url} />}
            </Helmet>
            <BlogLayout mobileNoPadding={true} noStats={!caseStudy.showStats}
                        imageUrl={caseStudy.mainImage.url} brandImageUrl={caseStudy.brandImage.url}
                        title={caseStudy.caseTitle} description={caseStudy.caseDescription} hideDivider>
                <div className={`textContainer ${styles.topTextContainer}`}>
                    {caseStudy.caseDescription &&
                        <p className={styles.excerpt} dangerouslySetInnerHTML={{ __html: caseStudy.caseDescription }} />
                    }
                    <div className={styles.info}>
                        <div>Case Study: {caseStudy.brandName}</div>
                        {caseStudy.caseDate && <div>{caseStudy.caseDate}</div>}
                    </div>
                    {!caseStudy.showStats &&
                        <Divider direction={"horizontal"}/>
                    }
                </div>
            </BlogLayout>
                    {caseStudy.showStats &&
                        <CaseStats statsData={caseStudy.stats} />
                    }
                    <BlogLayout hideBackButton={true} hideBlogDefaultData>
                        <div className={styles.textContainer}>
                        <SideContent brandImage={caseStudy.brandImage} brandName={caseStudy.brandName} content={caseStudy.aboutTheBrand?.data.aboutTheBrand} title={caseStudy.aboutTheBrandTitle}/>
                            <ReactMarkdown className={styles.content} source={caseStudy.mainContent?.data.mainContent}/>
                        </div>
                    </BlogLayout>
        </StrapiLayout>
    );
};
export const query = graphql`
  query($slug: String!) {
    allStrapiCaseStudy(filter: { slug: { eq: $slug } }) {
      edges {
              node {
                pageTitle
                pageDescription
                mainImage {
                    url
                }
                brandImage {
                    url
                }
                caseTitle
                brandName
                mainContent { 
                        data {
                            mainContent
                        }
                    }
                aboutTheBrand {
                        data {
                            aboutTheBrand
                        }
                    }
                aboutTheBrandTitle
                showStats
                stats {
                    label
                    icon
                    data
                }
              }
      }
    }
    strapiFooter {
        columns {
          title
          links {
            text
            url
          }
        }
        backgroundShapes {
            color
            shapeId
            side
        }
      }
  }
`;